import { takeLatest, put, call, select, all } from 'redux-saga/effects';

import * as actionTypes from 'constants/ActionTypes';
import { INTERVENTION_MODE } from 'constants/InterventionConstants';
import { PATH } from 'constants/RoutesConstants';
import { STEP_DEFAULT_SMS, FIXED_STEP_NAME } from 'constants/StepsConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchCameras } from 'modules/cameras/actions';
import { StepsCodeEnum } from 'modules/global/typing/enums/steps.enum';
import { fetchTranslations } from 'modules/i18n/actions';
import { getUserGroups } from 'modules/userGroups/actions';
import { getLanguages } from 'selectors/languageSelectors';

import { getDealer } from './utils';
import { fetchStepsFailure, fetchStepsSuccess } from '../actions/core';

function* initializeStepDashboard(action) {
  try {
    const dealer = yield call(getDealer);
    const languages = yield select(getLanguages);

    yield all([
      putAndWait(
        fetchTranslations({
          languages,
          keys: [FIXED_STEP_NAME[StepsCodeEnum.READY].id, STEP_DEFAULT_SMS],
        })
      ),
      put(getUserGroups(dealer.id)),
    ]);
    yield all([
      put(
        fetchStepsSuccess(
          dealer.id,
          {
            PARTS: dealer.config.steps?.[INTERVENTION_MODE.PARTS]?.steps ?? [],
            SALES: dealer.config.steps?.[INTERVENTION_MODE.SALES]?.steps ?? [],
            TECHNICIAN: dealer.config.steps?.[INTERVENTION_MODE.TECHNICIAN]?.steps ?? [],
          },
          action?.meta
        )
      ),
      putAndWait(fetchCameras({ dealerId: dealer.id })),
    ]);
  } catch (error) {
    yield put(fetchStepsFailure(error?.message ?? error, action?.meta));
  }
}

function* onDashboardWorker() {
  yield call(initializeStepDashboard);
  yield takeLatest(actionTypes.SELECT_DEALER, initializeStepDashboard);
}

export default function* stepsDashboardSaga() {
  yield scopeToPage([PATH.STEPS_DASHBOARD], onDashboardWorker);
}
